<template>
    <div>
        <app-header></app-header>
        <main id="page-main" class="with-tabs">
            <nav>
                <ul>
                    <li><router-link :to="{ name: 'fidelity-dashboard' }"><i class="icon icon-icon_home"></i></router-link></li>
                    <li xv-if="$store.state.modules.indexOf('fidelity.account')>=0"><router-link :to="{ name: 'account' }"><i class="icon icon-icon_card"></i> Cartes de fidélité</router-link></li>
                </ul>
            </nav>
            <router-view></router-view>
        </main>
    </div>
</template>
<script>

    export default {
        name: 'Company',
        data () {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/fidelity/Index.vue